<template>
  <div class="add-or-edit-material">
    <el-page-header @back="goBack" :content="pathTitle"> </el-page-header>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="材料图片">
        <label>
          <input id="image" accept="image/*" type="file" @change="onMarerialChange" style="display: none" />
          <img class="preview-img clickable" id="imagePreview" :src="form.imageUrl" :onerror="defaultImg" style="width: 70px; height: 70px; vertical-align: top; cursor: pointer" />
        </label>
      </el-form-item>
      <el-form-item label="asin">
        <div v-if="productAsin != ''">
          <img class="preview-img clickable" :src="productImgUrl" :onerror="defaultImg" style="width: 70px; height: 70px; vertical-align: middle" />
          <span style="margin: 0px 10px; vertical-align: middle">{{ productAsin }}</span>
          <el-button @click="clearProductInfo" size="small" type="text" style="vertical-align: middle">清除</el-button>
        </div>
        <el-button @click="selectMaterial" size="small" type="text" v-if="productAsin == ''">请选择</el-button>
      </el-form-item>
      <el-form-item label="中文名称">
        <el-input v-model="form.name" style="width: 217px"></el-input>
      </el-form-item>
      <el-form-item label="规格描述">
        <el-input v-model="form.description" style="width: 217px"></el-input>
      </el-form-item>
      <el-form-item label="样品位置">
        <el-input v-model="form.locationOfSampleCabinet" style="width: 217px"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" style="width: 217px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="goBack" size="small" style="width: 80px">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="small" style="width: 80px">确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="选择材料" :visible.sync="dialogVisible">
      <div class="search-box">
        <span style="margin-right: 5px">材料Id/asin/中文简称</span>
        <el-input v-model="searchKey" size="mini" style="width: 217px"></el-input>
      </div>
      <div class="material-list-box">
        <el-radio-group v-model="asin" size="mini">
          <div class="material-item" v-for="item in dialogProductList">
            <img class="material-img" src="item.smallImageURL" />
            <el-radio class="radio-item" :label="item.asin" @change="onMaterialSelectChange(item)">{{ item.asin }}</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="opreate-box">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogConfirmClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { productModules, materialModules } from "@r";
import utils from "../../../utils/utils.js";
export default {
  data() {
    return {
      form: {
        imageUrl: "",
        name: "",
        description: "",
        locationOfSampleCabinet: "",
        remark: "",
        untieAsinFlag: "0",
      },
      pathTitle: "",
      fileList: [],
      images: [],
      imgBase64Params: [],
      imageUrl: "",
      searchKey: "",
      dialogVisible: false,
      asin: "",
      productAsin: "",
      productImgUrl: "",
      productList: [],
      selectMaterialInfo: {},
      materialId: -1,
    };
  },
  activated() {
    this.materialId = this.$route.query.materialId;
    this.pathTitle = this.materialId == -1 ? "新增材料" : "编辑材料";
    this.listAmazonProductGroupByAsin();
    this.listMaterial();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onSubmit() {
      var params = new FormData();
      this.materialId != -1 && params.append("id", this.materialId);
      params.append("asin", this.productAsin);
      params.append("name", this.form.name);
      params.append("description", this.form.description);
      params.append("locationOfSampleCabinet", this.form.locationOfSampleCabinet);
      params.append("remark", this.form.remark);
      this.form.imageUrl.startsWith("data:image/") && params.append("imageBASE64", this.form.imageUrl);
      params.append("untieAsinFlag", this.form.untieAsinFlag);

      this.$confirm("是否确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          materialModules
            .addOrUpdate(params)
            .then(res => {
              if (res.result !== 1) {
                this.$message({
                  type: "error",
                  message: res.message ? res.message : "操作失败",
                });
                return;
              }

              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.goBack();
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message ? err.message : "未知错误",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    selectMaterial() {
      this.dialogVisible = true;
    },
    onMarerialChange(e) {
      utils.localResizeImg(e, this.form, "imageUrl");
    },
    listMaterial() {
      materialModules
        .list({
          "rawMaterialId": this.materialId,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          if (res.ldata.length > 0) {
            this.form.imageUrl = res.ldata[0].smallImageURL;
            this.form.name = res.ldata[0].name;
            this.form.description = res.ldata[0].description;
            this.form.locationOfSampleCabinet = res.ldata[0].locationOfSampleCabinet;
            this.form.remark = res.ldata[0].remark;
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    listAmazonProductGroupByAsin() {
      productModules
        .listAmazonProductGroupByAsin({})
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.productList = res.ldata;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    dialogConfirmClick() {
      this.dialogVisible = false;
      this.productAsin = this.selectMaterialInfo.asin;
      this.productImgUrl = this.selectMaterialInfo.smallImageURL;
      this.untieAsinFlag = "1";
    },
    clearProductInfo() {
      this.productAsin = "";
      this.productImgUrl = "";
      this.selectMaterialInfo = {};
      this.untieAsinFlag = "1";
    },
    onMaterialSelectChange(info) {
      this.selectMaterialInfo = info;
    },
  },
  computed: {
    materialImgUrl() {
      return this.form.imageUrl != "" ? this.form.imageUrl : "";
    },
    defaultImg() {
      return "";
    },
    dialogProductList() {
      var list = [];
      for (var i = 0; i < this.productList.length; i++) {
        var info = this.productList[i];
        var isMatch = false;
        if (this.searchKey == "" || this.searchKey == null) {
          isMatch = true;
        }
        if (info.id != null && info.id.toString().indexOf(this.searchKey.toLowerCase()) != -1) {
          isMatch = true;
        }
        if (info.sortAsin != null && info.sortAsin.toLowerCase().indexOf(this.searchKey.toLowerCase()) != -1) {
          isMatch = true;
        }
        if (info.innerName != null && info.innerName.toLowerCase().indexOf(this.searchKey.toLowerCase()) != -1) {
          isMatch = true;
        }
        isMatch && list.push(info);
      }
      return list;
    },
  },
};
</script>

<style lang="scss">
.el-form {
  margin-top: 20px;
}
.search-box {
  border-bottom: solid 1px #409eff;
  margin-bottom: 8px;
  padding-bottom: 8px;
}
.material-list-box {
  height: 450px;
  overflow-y: auto;

  .material-item {
    display: inline-block;
    width: 180px;
    height: 30px;
    line-height: 30px;

    .material-img {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      margin-right: 2px;
    }
    .el-radio {
      vertical-align: middle;
    }
  }
}
.opreate-box {
  text-align: center;
  margin-top: 10px;
}
</style>
